import { render, staticRenderFns } from "./vediTesi.vue?vue&type=template&id=70c150df&"
import script from "./vediTesi.vue?vue&type=script&lang=js&"
export * from "./vediTesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports